export default "__VITE_ASSET__C93Nqevt__"